
import { mixins, Options } from 'vue-class-component';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import MRedemptionDetails from './redemption/MRedemptionDetails.vue';
import MRedemptionSelection from './redemption/MRedemptionSelection.vue';

@Options({
  components: {
    MRedemptionDetails,
    MRedemptionSelection
  }
})
export default class MUrl extends mixins(CampaignWidgetMixin) {}
